import { Base } from './base'
import Authentication from './features/authentication'
import Contract from './features/contract'
import ContractRenovation from './features/contract-renovation'
import Equipment from './features/equipment'
import EquipmentVista from './features/equipment-vista'
import EquipmentVistaItem from './features/equipment-vista-item'
import Order from './features/order'
import OrderConsumedItem from './features/OrderConsumedItem'
import OrderItem from './features/orderItem'
import Person from './features/person'
import PersonAddress from './features/person-address'
import PersonContact from './features/person-contact'
import Product from './features/product'
import Storage from './features/storage'
import StorageItem from './features/storage[item]'
import StorageTransaction from './features/storage[transaction]'

// prettier-ignore
export class Api extends Base {
  Authentication     = new Authentication(this.axios)
  Contract           = new Contract(this.axios)
  ContractRenovation = new ContractRenovation(this.axios)
  Equipment          = new Equipment(this.axios)
  EquipmentVista     = new EquipmentVista(this.axios)
  EquipmentVistaItem = new EquipmentVistaItem(this.axios)
  Order              = new Order(this.axios)
  OrderConsumedItem  = new OrderConsumedItem(this.axios)
  OrderItem          = new OrderItem(this.axios)
  Person             = new Person(this.axios)
  PersonAddress      = new PersonAddress(this.axios)
  PersonContact      = new PersonContact(this.axios)
  Product            = new Product(this.axios)
  Storage            = new Storage(this.axios)
  StorageItem        = new StorageItem(this.axios)
  StorageTransaction = new StorageTransaction(this.axios)
}
